import { render, staticRenderFns } from "./InputCnpj.vue?vue&type=template&id=5e21b5ee"
import script from "./InputCnpj.vue?vue&type=script&lang=js"
export * from "./InputCnpj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports